import { render } from "./SetLeadStatusForm.vue?vue&type=template&id=8d2b7d36"
import script from "./SetLeadStatusForm.vue?vue&type=script&lang=js"
export * from "./SetLeadStatusForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__